import Connect from "../Connect";

export default function Contact() {
  return (
    <div className="mt-32 border-t-2 border-light-text dark:border-dark-text">
      <Connect />
    </div>
  );
}
